module.exports = __webpack_public_path__ + "static/img/image_map.d9d99fc6.png";